import React from 'react';
import createReactClass from 'create-react-class';
import DashboardClient from './common/dashboard_client';
import PanelSpinner from './common/panel_spinner';
import ReportError from './report_error';
import { enhancedDatadealPresentation } from './enhanced_datadeal_progress_presentation';

// `enhanced_datadeal_progress` is the established internal report contract.
// Contributor-facing copy is intentionally kept in the 3D Partner Program presentation.
const EnhancedDatadealProgress = createReactClass({
  displayName: 'EnhancedDatadealProgress',
  mixins: [DashboardClient],
  endpoint() {
    return '/turbosquid/dashboard_widgets/enhanced_datadeal_progress.json';
  },
  progress() {
    return this.state.data.enhanced_datadeal_progress[0];
  },
  presentation() {
    return enhancedDatadealPresentation(this.progress());
  },
  qualifyingAssetCount() {
    return Number(this.progress().qualifying_asset_count) || 0;
  },
  qualifyingAssetGoal() {
    return Number(this.progress().qualifying_asset_goal) || 12;
  },
  completionPercent() {
    const goal = this.qualifyingAssetGoal();

    return goal > 0 ? Math.min(100, Math.round((this.qualifyingAssetCount() / goal) * 100)) : 0;
  },
  progressPercent() {
    return this.presentation().qualifies ? 100 : this.completionPercent();
  },
  progressMessage(remaining) {
    if (!this.presentation().optedIn || this.presentation().qualifies || remaining < 1) {
      return this.presentation().message;
    }

    const modelLabel = remaining === 1 ? 'model' : 'models';

    return `Publish ${remaining === 1 ? 'one' : remaining} more qualifying ${modelLabel} to meet the program requirement.`;
  },
  icon() {
    if (this.presentation().icon === 'unlock-award') {
      return (
        <span className="enhanced-datadeal-progress__unlock-award" aria-hidden="true">
          <i className="fa fa-certificate" />
          <i className="fa fa-unlock-alt" />
        </span>
      );
    }

    return <i className={`fa ${this.presentation().icon}`} aria-hidden="true" />;
  },
  render() {
    if (this.reportsDisabled()) return null;
    if (this.state.data == null) return <PanelSpinner />;
    if (this.state.data.aggregations && this.state.data.aggregations.error) return <ReportError />;

    const progress = this.progress();
    if (progress == null) return null;
    const presentation = this.presentation();
    const remaining = Number(progress.qualifying_asset_count_remaining) || 0;
    const progressPercent = this.progressPercent();
    const faqUrl = gon.three_d_partner_program_faq_url;

    return (
      <div className={`panel-body text-left enhanced-datadeal-progress enhanced-datadeal-progress--${presentation.tone}`}>
        <div className="enhanced-datadeal-progress__icon">{this.icon()}</div>
        <div className="enhanced-datadeal-progress__content">
          <div className="enhanced-datadeal-progress__header">
            <div className="enhanced-datadeal-progress__heading">
              <h4>3D Partner Program</h4>
              <span className="enhanced-datadeal-progress__status">{presentation.status}</span>
              <span className="enhanced-datadeal-progress__opt-in-status">{presentation.optInStatus}</span>
            </div>
            <a
              className="enhanced-datadeal-progress__faq"
              href={faqUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              Program FAQ <i className="fa fa-external-link" aria-hidden="true" />
            </a>
          </div>
          <p className="enhanced-datadeal-progress__message">{this.progressMessage(remaining)}</p>
          <div className="enhanced-datadeal-progress__count-row">
            <p className="enhanced-datadeal-progress__count">
              {this.qualifyingAssetCount()} of {this.qualifyingAssetGoal()} qualifying models
            </p>
            <span className="enhanced-datadeal-progress__result">
              {presentation.qualifies ? 'Requirement met' : `${progressPercent}%`}
            </span>
          </div>
          <div className="enhanced-datadeal-progress__progress">
            <div
              aria-label="Qualifying models toward 3D Partner Program requirement"
              aria-valuemax={this.qualifyingAssetGoal()}
              aria-valuemin="0"
              aria-valuenow={Math.min(this.qualifyingAssetCount(), this.qualifyingAssetGoal())}
              className="enhanced-datadeal-progress__progress-track"
              role="progressbar"
            >
              <div className="enhanced-datadeal-progress__progress-value" style={{ width: `${progressPercent}%` }} />
            </div>
          </div>
          <div className="enhanced-datadeal-progress__footer">
            {presentation.qualifies && <p className="enhanced-datadeal-progress__detail">{presentation.detail}</p>}
            {!presentation.qualifies && <a className="enhanced-datadeal-progress__help" href={faqUrl}>How qualifying models work</a>}
            {!presentation.optedIn && (
              <a className="btn btn-warning enhanced-datadeal-progress__action" href={gon.turbosquid_seller_url}>
                Opt in to Data Deals
              </a>
            )}
          </div>
        </div>
      </div>
    );
  },
});

export default EnhancedDatadealProgress;
